import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-eye-off",
  templateUrl: "./eye-off.component.html",
  styleUrls: ["./eye-off.component.scss"],
})
export class EyeOffComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
